import {
  useDialogFocusTrap as useSharedDialogFocusTrap,
  type UseDialogFocusTrapOptions,
} from '@quality-vet/ui/modal-focus-trap';

type DialogHookRef = Parameters<typeof useSharedDialogFocusTrap>[0];

export function useDialogFocusTrap(
  dialogRef: DialogHookRef,
  onClose: () => void,
  active = true,
  options?: Omit<UseDialogFocusTrapOptions, 'active'>,
): void {
  useSharedDialogFocusTrap(dialogRef, onClose, {
    ...options,
    active,
  });
}
